var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 189,
    viewBox: "0 0 800 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_5482)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 189,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.540123
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.728 -17.9226L392.877 -3.69826L373.041 -16.1331L387.891 -30.3573L407.728 -17.9226Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.687848
  }, /*#__PURE__*/React.createElement("path", {
    d: "M648.689 131.671L631.865 119.849L640.234 97.985L657.058 109.806L648.689 131.671Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M613.115 4.61229L611.798 20.4382L593.96 23.3904L595.277 7.56455L613.115 4.61229Z",
    fill: "#5B921B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7422 163.042L32.844 173.841L20.6719 175.856L21.5701 165.057L33.7422 163.042Z",
    fill: "#5B921B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.673 7.80495L356.87 20.3095L342.841 22.9053L343.644 10.3997L357.673 7.80495Z",
    fill: "#DAFD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.671 7.80495L768.868 20.3095L754.839 22.9053L755.642 10.3997L769.671 7.80495Z",
    fill: "#22E06C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.770925
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608.85 133.069L613.286 121.35L627.458 122.984L623.023 134.704L608.85 133.069Z",
    fill: "#DAFD82"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.770925
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.027 171.574L673.506 171.086L670.558 157.128L683.08 157.614L686.027 171.574Z",
    fill: "#7ED321"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M778.027 118.574L765.506 118.086L762.558 104.128L775.08 104.614L778.027 118.574Z",
    fill: "#5B921B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.770925
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0274 85.5736L62.5063 85.086L59.5582 71.1278L72.0797 71.614L75.0274 85.5736Z",
    fill: "#22E06C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M459.907 47.9178L471.885 51.5978L471.158 65.8462L459.18 62.1676L459.907 47.9178Z",
    fill: "#DAFD82"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.288293
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.653 92.9242L316.526 100.303L305.56 91.1758L315.688 83.7964L326.653 92.9242Z",
    fill: "#E2FFBA"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.687848
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.177 133.75L115.321 143.273L107.072 154.914L98.9281 145.391L107.177 133.75Z",
    fill: "#DAFD82"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.667 111.123C227.508 111.869 226.341 112.606 225.11 113.178C221.698 114.759 217.698 115.025 214.108 113.912C208.996 112.327 204.78 108.106 199.452 107.596C194.742 107.146 190.284 109.73 186.567 112.657C182.849 115.584 179.382 119.01 174.986 120.759C169.424 122.97 163.239 122.186 157.234 121.713",
    stroke: "#5B921B",
    strokeOpacity: 0.961672,
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.471 40.7871C721.572 41.832 720.663 42.8703 719.645 43.7685C716.824 46.2543 713.065 47.6478 709.306 47.6012C703.954 47.5356 698.713 44.6882 693.46 45.7146C688.816 46.6223 685.277 50.3676 682.546 54.231C679.814 58.0945 677.465 62.3653 673.748 65.292C669.044 68.9938 662.892 70.001 657 71.2552",
    stroke: "#DAFD82",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.747 24.0138C507.73 23.3442 503.439 24.397 500.836 27.4651C496.597 32.4588 498.342 40.2583 501.941 45.7305C503.089 47.4758 504.442 49.1542 506.248 50.2057C510.205 52.5103 515.225 51.2874 519.505 49.6585C531.021 45.276 541.557 38.3388 550.134 29.4921C553.107 26.4247 555.879 23.0842 557.688 19.2152C558.165 18.1976 558.57 17.1517 558.915 16.0864",
    stroke: "#DAFD82",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.184 154.309C325.144 154.286 325.103 154.264 325.063 154.242C320.603 151.783 315.792 148.92 310.78 149.811C304.82 150.871 301.027 156.912 299.541 162.78C298.702 166.095 297.853 170.145 294.616 171.253C292.226 172.073 289.677 170.801 287.449 169.612C279.576 165.416 269.627 161.9 262.156 166.774C256.019 170.779 252.815 179.803 245.507 180.345C238.978 180.831 233.998 173.854 227.474 173.301C221.455 172.792 216.963 177.63 212.001 181.484",
    stroke: "#DAFD82",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.891 81.8918C307.582 80.4343 307.179 79.017 306.556 77.7094C304.578 73.5589 300.158 70.6898 295.561 70.5707C288.227 70.383 280.542 76.4473 274.196 72.7635C268.445 69.4252 268.668 60.4868 263.491 56.313C260.416 53.8352 256.12 53.615 252.184 53.9258C244.474 54.5357 235.791 56.4903 229.704 51.7199C228.689 50.9247 227.817 49.9843 227 48.9896",
    stroke: "#00CE60",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.196 59.4969C156.839 59.7338 155.473 59.905 154.106 60.0074C142.36 60.8901 129.815 56.869 122.481 47.6521C115.147 38.436 114.539 23.7749 122.71 15.2907C124.82 13.1 127.506 11.3356 130.514 10.8899C133.522 10.4442 136.854 11.5169 138.597 14.0095C140.454 16.6665 140.202 20.2671 139.302 23.3812C135.456 36.707 121.852 45.0852 108.296 48.0233C96.8094 50.5135 84.3856 49.9116 73.8719 44.6578C65.2055 40.3273 58.1298 32.8971 54.2291 24.0306C52.8606 20.9211 51.8611 17.4861 52.4887 14.1469C53.0171 11.3333 54.6558 8.84884 56.5307 6.68445C56.949 6.20105 57.3902 5.72674 57.8503 5.26908",
    stroke: "#DAFD82",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.624 100.624C515.768 101.692 516.105 102.748 516.548 103.73C519.167 109.542 525.507 113.269 531.881 113.398C538.254 113.528 544.464 110.34 548.636 105.521C551.908 101.743 554.065 96.6347 553.034 91.7454C552.398 88.726 550.54 85.9805 547.974 84.2663C545.367 82.5245 540.966 82.4265 539.907 85.3761C539.503 86.5008 539.735 87.7532 540.115 88.8852C542.085 94.7425 547.873 98.756 553.948 99.8943C560.022 101.034 566.319 99.6852 572.097 97.494C577.812 95.3281 583.474 92.0864 586.544 86.8014C590.385 80.1907 589.065 71.0699 583.642 65.6814C581.822 63.8732 579.09 62.5191 576.679 62.7073",
    stroke: "#00CE60",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.094 158.725C475.396 160.133 476.503 161.777 477.495 163.412C479.518 166.746 481.374 170.334 484.463 172.712C487.552 175.092 492.353 175.827 495.2 173.163C496.46 171.985 497.189 170.299 498.544 169.23C501.36 167.007 505.614 168.357 508.39 170.63C511.166 172.905 513.293 176.001 516.437 177.731C520.109 179.751 524.919 179.498 528.357 177.1C528.618 176.917 528.876 176.722 529.131 176.518",
    stroke: "#5B921B",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.291 101.194C389.706 100.644 391.028 99.891 392.195 98.887C395.613 95.947 396.917 90.334 394.416 86.761",
    stroke: "white",
    strokeWidth: 4.829,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 49,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#22E06C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.14 85.4793L393.484 118.877L376 102.797L381.586 96.723L392.889 107.119L416.969 80L423.14 85.4793Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_5482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 189,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.1bf98b948a4243fb3496c5e7b4dbb02c.svg";
export { ForwardRef as ReactComponent };